module.exports = __webpack_public_path__ + "static/media/banner-1920.e49c165e.jpg";